// src/features/auth/msal/msalClient.js
import { PublicClientApplication, EventType } from "@azure/msal-browser";

const env = (viteKey, craKey) =>
  (typeof import.meta !== "undefined" && import.meta.env?.[viteKey]) ||
  process.env?.[craKey] ||
  "";

// Básico
export const TENANT       = env("VITE_TENANT_ID", "REACT_APP_TENANT_ID");
export const CLIENT_ID    = env("VITE_CLIENT_ID", "REACT_APP_CLIENT_ID");
export const REDIRECT_URI =
  env("VITE_REDIRECT_URI", "REACT_APP_REDIRECT_URI") ||
  (typeof window !== "undefined" ? window.location.origin : "");

// Scopes
const EXPLICIT_API_SCOPE = env("VITE_API_SCOPE", "REACT_APP_API_SCOPE"); // ex: api://<API_APP_ID>/.default
const API_APP_ID         = env("VITE_API_APP_ID", "REACT_APP_API_APP_ID"); // opcional (fallback)

// Hoje (dev): se não tiver VITE_API_SCOPE, caímos no .default do APP ID (se informado)
const FALLBACK_SCOPE = API_APP_ID ? `api://${API_APP_ID}/.default` : "";

export const API_SCOPE  = EXPLICIT_API_SCOPE || FALLBACK_SCOPE;
export const LOGIN_MODE = (env("VITE_LOGIN_MODE", "REACT_APP_LOGIN_MODE") || "redirect").toLowerCase();

export const SCOPES_ID  = ["openid", "profile", "email"];
export const SCOPES_API = API_SCOPE ? [API_SCOPE] : [];

export const pca = new PublicClientApplication({
  auth: {
    clientId: CLIENT_ID,
    authority: `https://login.microsoftonline.com/${TENANT}`,
    redirectUri: REDIRECT_URI,
    navigateToLoginRequestUrl: false,
  },
  cache: {
    cacheLocation: "localStorage", // em produção, considere "sessionStorage"
    storeAuthStateInCookie: false,
  },
});

// Mantém a conta ativa atualizado
pca.addEventCallback((ev) => {
  if (ev.eventType === EventType.LOGIN_SUCCESS && ev.payload?.account) {
    pca.setActiveAccount(ev.payload.account);
  }
});
